import React, { Component } from "react"
import { OverlayTrigger, Popover, Spinner, Tooltip } from "react-bootstrap"
import { shouldAllowAccess } from "src/utilities/helper"
import "./ReviewControlBar.css"

interface Props {
    loading: boolean
    manageParentState: Function
    isDirty: boolean
    missingFields: Array<String>
    submitted: null | string
    readOnly: boolean
    updateReview: Function
}


class ReviewControlBar extends Component<Props, {}> {

    handleSave = () => {
        if(!this.props.submitted){
            this.props.manageParentState([{key: "submitNag", value: true}])
        }else{
            this.props.updateReview()
        }
    }

    render() {

        const props = this.props
        let readOnly = props.readOnly

        if (shouldAllowAccess("HR:REVIEW-WRITER") || shouldAllowAccess("HR:ADMIN")) {
            readOnly = false
        }

        const ControlBarToolTip = (text: string) => (
            <Tooltip id="review-control-bar-tool-tip">
                {text}
            </Tooltip>
        )

        const MissingFieldPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h2">Please check the following fields:</Popover.Title>
                {props.missingFields.map((item: any, index: number) =>
                    <div className="uac-missing-info-tooltip-text" key={`miss-comp-${index}`}>
                        <p className="uac-missing-info-tooltip-text-item-number">{`${index + 1}. `}</p>
                        <p className="uac-missing-info-tooltip-text-item">{item.replace(/([A-Z])/g, ' $1').trim()}</p>
                    </div>
                )}
            </Popover>
        )

        return (
            <div className="ReviewControlBar">
                {props.loading && <Spinner id="review-control-bar-spinner" animation="border" />}
                {/* {!props.submitted && <div className="ReviewControlBarCanSubmit"> */}
                {!props.loading && !readOnly && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={ControlBarToolTip("Delete this review")}>
                    <div className="DeleteReviewBtn" onClick={() => props.manageParentState([{ key: "confirmDelete" }])}>
                        <span id="delete-review-btn" className="material-icons">delete</span>
                    </div>
                </OverlayTrigger>}
                {props.isDirty && !props.loading && !readOnly && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={ControlBarToolTip("Save Review")}>
                    <div className="ReviewControlBarBtn" id="review-save-btn" onClick={() => this.handleSave()}>
                        <p>Save</p>
                        <span className="material-icons">save</span>
                    </div>
                </OverlayTrigger>}
                {!props.isDirty && !props.loading && !readOnly && props.missingFields.length === 0 &&  <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={ControlBarToolTip("Nothing to save")}>
                    <div className="ReviewControlBarBtn" id="review-cant-save-btn">
                        <p>Save</p>
                        <span className="material-icons">save</span>
                    </div>
                </OverlayTrigger>}
                {!props.isDirty && !props.loading && !readOnly && props.missingFields.length > 0 &&  <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={MissingFieldPopover}>
                    <div className="ReviewControlBarBtn ReviewControlBarBtnOMGFML" id="review-cant-save-btn">
                        <p>Save</p>
                        <span className="material-icons">save</span>
                    </div>
                </OverlayTrigger>}
                {/* </div>} */}
                {/* {props.submitted && <div className="ReviewControlBarCantSubmit">
                    <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={ControlBarToolTip("Review has already been submitted")}>
                        <div className="ReviewControlBarBtn" id="review-cant-re-submit-btn">
                            <p>Locked</p>
                            <span className="material-icons">lock</span>
                        </div>
                    </OverlayTrigger>
                 </div>} */}
            </div>
        )
    }
}

export default ReviewControlBar